<template>
  <modelling-component />
</template>

<script>
import ModellingComponent from "@/components/modelling/modelling";
export default {
  components: {
    ModellingComponent
  }
};
</script>

<style></style>
